var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadTheAppIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9688,
    cy: 24.5,
    r: 24,
    fill: "#067B65",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_531_18751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1196 36.1563H12.3696C12.1152 36.1563 11.8632 36.1061 11.6282 36.0088C11.3931 35.9114 11.1795 35.7687 10.9996 35.5888C10.6363 35.2254 10.4321 34.7326 10.4321 34.2188V12.9063C10.4321 12.3924 10.6363 11.8996 10.9996 11.5362C11.363 11.1729 11.8558 10.9688 12.3696 10.9688H31.7446C31.9991 10.9688 32.251 11.0189 32.4861 11.1162C32.7211 11.2136 32.9347 11.3563 33.1147 11.5362C33.2946 11.7161 33.4373 11.9297 33.5346 12.1648C33.632 12.3999 33.6821 12.6518 33.6821 12.9063V21.625M20.1196 16.7813H27.8696M16.2446 22.5938H27.8696M16.2446 28.4063H25.9321M38.6951 29.2071L28.8435 39.0625L23.9998 40.0313L24.9685 35.1875L34.8253 25.3321C35.0788 25.0781 35.3799 24.8766 35.7113 24.7391C36.0428 24.6017 36.3981 24.5309 36.7569 24.5309C37.1158 24.5309 37.4711 24.6017 37.8026 24.7391C38.134 24.8766 38.4351 25.0781 38.6886 25.3321L38.7003 25.3424C39.212 25.8556 39.4989 26.5511 39.4979 27.2758C39.4969 28.0006 39.2082 28.6952 38.6951 29.2071Z",
    stroke: "#067B65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_531_18751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8.96875 9.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadTheAppIcon);
export default __webpack_public_path__ + "static/media/DownloadTheAppIcon.60f31912aaf2b53cf09d7fd859c55f3a.svg";
export { ForwardRef as ReactComponent };